import styled from "@emotion/styled"
import {
  offWhite,
  Fira,
  darkGrey,
  logoOrangeLighten,
  logoRed,
} from "../../globalCss"
import { Link } from "gatsby"

export const FooterWrapper = styled.footer`
  width: 100%;
  background-color: ${offWhite};
  border-top: #f3f4f6 1px solid;
`

export const FooterContainer = styled.div`
  ${Fira}
  color: ${darkGrey};
  margin: 0 auto;
  position: relative;
  max-width: 1200px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding: 6rem 2rem;
  z-index: 10;
  flex-wrap: wrap;
`

export const Column = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  h3 {
    color: ${logoRed};
    font-weight: 700;
    font-size: 1.8rem;
    margin-bottom: 2rem;
    text-transform: uppercase;
    letter-spacing: 0.15rem;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 1.6rem;
    line-height: 1.8;
    margin-bottom: 2rem;
    
  a {
      color: inherit;
      text-decoration: none; 

      &:hover {
        color: ${logoRed}
      }
  }

    img {
      height: 3rem;
      width: 3rem;
      margin: 0.5rem 0rem;
    }
  }
`
